import {
  Card,
  Row,
  Col,
  Input,
  Button,
  Divider,
  Select,
  Typography,
  Flex,
} from "antd";


import dayjs from "dayjs";
import { CloseOutlined } from "@ant-design/icons";
import { useState } from "react";
const { Title, Text } = Typography;
const { Option } = Select;


const LeadGuestDetails = ({ selectedDate, adult, child, price, onBack }) => {
  const [promoCode, setPromoCode] = useState("");
  const [infant, setInfant] = useState(0);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const packages = [
    {
      title: "Silver Pass with Penguin Cove",
      transfer: "Sharing Transfer",
      price: 74872,
      discount: "5% off",
      features: [
        "Entry to Dubai Aquarium & Underwater Zoo",
        "Access to Aquarium Tunnel",
        "Access to Penguin Cove & Nursery",
        "AED 20 retail shop credit",
      ],
    },
    {
      title: "Silver Pass with Penguin Cove",
      transfer: "Private Transfer",
      price: 74872,
      discount: "5% off",
      features: [
        "Hotel pickup & drop",
        "Entry anytime 10:00am – 10:00pm",
        "Access to Aquarium Tunnel",
        "Penguin Cove & Nursery",
      ],
    },
    {
      title: "Silver Pass with Penguin Cove",
      transfer: "Without Transfer",
      price: 74872,
      discount: "5% off",
      features: [
        "Without transfer",
        "Entry anytime 10:00am – 10:00pm",
        "Aquarium Tunnel",
        "Penguin Cove access",
      ],
    },
    {
      title: "Silver Pass with Penguin Cove",
      transfer: "Without Transfer",
      price: 74872,
      discount: "5% off",
      features: [
        "Without transfer",
        "Entry anytime 10:00am – 10:00pm",
        "Aquarium Tunnel",
        "Penguin Cove access",
      ],
    },
    {
      title: "Silver Pass with Penguin Cove",
      transfer: "Without Transfer",
      price: 74872,
      discount: "5% off",
      features: [
        "Without transfer",
        "Entry anytime 10:00am – 10:00pm",
        "Aquarium Tunnel",
        "Penguin Cove access",
      ],
    },
  ];
  const [step, setStep] = useState(1); // 1 = package, 2 = lead guest
  return (
    <Card className="card-no-border card-no-padding guestForms">
      <Title
        level={2}
        className="!font-medium guest-title !text-primary !text-2xl"
      >
        Lead guest details
      </Title>

      <Row gutter={40}>
        <Col md={18}>
          <Row gutter={16}>
            <Col md={12}>
              <label htmlFor="Full Name">Full Name</label>
              <Input placeholder="Full Name" size="large" className="mb-4" />
            </Col>

            <Col md={12}>
              <label htmlFor="Full Name">Phone Number / WhatsApp Number</label>
              <Input
                size="large"
                className="mb-4"
                addonBefore={
                  <Select defaultValue="+971" style={{ width: 90 }}>
                    <Option value="+971">🇦🇪 +971</Option>
                    <Option value="+91">🇮🇳 +91</Option>
                  </Select>
                }
                placeholder="Phone Number / WhatsApp Number"
              />
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12}>
              <label htmlFor="Full Name">Email</label>
              <Input size="large" className="mb-4" placeholder="Enter Email" />
            </Col>
            <Divider />
            <Col md={24}>
              {/* PROMO CODE */}
              <div className="flex items-center gap-3 mt-4 mb-4">
                <label htmlFor="Full Name" className="!mb-0 font-semibold">
                  Enter promo code
                </label>

                <Input
                  size="large"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  placeholder="Enter promo code"
                  className="rounded-full promoCode w-[200px]"
                  suffix={
                    promoCode && (
                      <CloseOutlined
                        onClick={() => setPromoCode("")}
                        className="cursor-pointer text-gray-400 hover:text-red-500"
                      />
                    )
                  }
                />

                <Button
                  type="danger"
                  size="middle"
                  className="px-12 py-4 h-[40px] text-sm rounded-full bg-danger text-white"
                >
                  Apply
                </Button>
              </div>
            </Col>
            <Divider />

            {/* ADDITIONAL DETAILS */}

            <Col md={24}>

              <Title
                level={2}
                className="!font-medium guest-title !text-primary !text-2xl"
              >
                Update Additional Details
              </Title>
            </Col>

            <Col md={12}>
              <label htmlFor="Full Name">
                Hotel / Pickup Location
              </label>
              <Input
                size="large"
                placeholder="Hotel / Pickup Location"
                className="mb-4"
              />

            </Col>
            <Col md={12}>
              <label htmlFor="Full Name">
                Room / Apartment No.
              </label>
              <Input
                placeholder="Room / Apartment No."

              />
            </Col>
            <Col md={12}>
              <label htmlFor="Full Name">
                Remarks
              </label>
              <Input placeholder="Remarks" className="mb-4" />
            </Col>
            <Col md={24}>

              <Button type="link" className="mt-4 px-0" onClick={onBack}>
                ← Back
              </Button>
            </Col>
          </Row>
        </Col>

        <Col md={6}>
          <Card className="mt-6 rounded-xl border p-[24px] border-[#E5E5E5] shadow-[0px_0px_4px_1px_rgba(0,0,0,0.1)]">
            <h3 className="!text-base font-medium text-[#0A2381]">
              Dubai Aquarium & Underwater Zoo with Penguin Cove Tickets
            </h3>
            <p className="text-[13px] text-[#C10707] mb-2 font-normal">
              Silver Pass with Penguin Cove - Private Transfer
            </p>
            <hr className="mt-4 mb-4" />
            <Flex justify="space-between" className="">
              <div className="flex flex-col">
                <div className="text-[13px] text-[#8C95A7] font-medium">
                  Dept. date:
                </div>
                <div className="text-sm font-medium">
                  {selectedDate.format("DD MMM YYYY")}
                </div>
              </div>

              <div className="flex flex-col">
                <div className="text-[13px] text-[#8C95A7] font-medium">
                  Time Slot
                </div>
                <div className="text-sm font-medium">
                  {selectedDate.format("hh:mm A")}
                </div>
              </div>
            </Flex>
            {/* Travelers: */}
            <div className="text-[13px] text-[#8C95A7] mb-2 mt-5 font-medium">
              Travelers:
            </div>
            <div className="flex justify-between mb-2">
              <div className="text-sm font-medium">Adult: {adult}</div>
              <div className="text-sm font-medium">AED 74872</div>
            </div>

            <div className="flex justify-between mb-2">
              <div className="text-sm font-medium">Child: {child}</div>
              <div className="text-sm font-medium">AED 0</div>
            </div>

            <div className="flex justify-between">
              <div className="text-sm font-medium">
                Infant: {infant}
              </div>
              <div className="text-sm font-medium">AED 0</div>
            </div>
            {/* Transfer (Meet at:) */}
            <div className="text-[13px] text-[#8C95A7] mt-5 font-medium">
              Transfer (Meet at:)
            </div>
            <p className="text-[13px] font-medium">
              Dubai Aquarium & Underwater Zoo, The Dubai Mall, Lower
              Ground Level, Downtown Dubai, Dubai
            </p>

            <Divider />
            <div className="flex justify-between mb-2">
              <div>
                <h3 className="!text-sm font-medium">Basic Price</h3>

              </div>
              <div>
                <h3 className="!text-sm font-medium text-right">
                  AED{" "}
                  {selectedPackage !== null
                    ? packages[selectedPackage].price
                    : 9, 744}
                </h3>

              </div>
            </div>

            <div className="flex justify-between my-4">

              <p className="!text-xs text-[#189527] font-semibold font-normal">
                Efficient Discount
              </p>


              <p className="!text-xs text-[#189527] font-semibold font-normal">
                AED 0,744
              </p>

            </div>

            <div className="flex justify-between mb-4">
              <div>
                <h3 className="!text-base font-medium">Total Amount</h3>
                <p className="!text-xs text-[#8C95A7] font-normal">
                  View Pricing Table
                </p>
              </div>
              <div>
                <h3 className="!text-base text-right">
                  AED{" "}
                  {selectedPackage !== null
                    ? packages[selectedPackage].price
                    : 0}
                </h3>
                <p className="!text-xs">*Excludes taxes</p>
              </div>
            </div>

            <Button
              block
              type="danger"
              size="middle"
              onClick={() => setStep(2)}
              className="w-full mt-4 px-12 py-5 text-sm rounded-md bg-danger text-white"
            >
              Next
            </Button>
          </Card>
        </Col>
      </Row>
    </Card>
  );
};

export default LeadGuestDetails;
